<template>
  <div>
    <b-card no-body class="overflow-hidden">
      <b-row no-gutters>
        <b-col md="6">
          <carousel-3d
            :controls-width="80"
            :controls-height="300"
            :width="360"
            :height="360"
            :controls-visible="true"
            :count="item.length"
          >
            <slide
              v-for="index in item.images.length"
              :key="index-1"
              :index="item.images[index-1].id"
            >
              <a v-b-modal="item.images[index-1].src">
                <b-img-lazy :src="item.images[index-1].src"></b-img-lazy>
              </a>
              <b-modal
                :id="item.images[index-1].src"
                class="openImageModal img-zoom-container"
                centered
                size="lg"
                ok-only
                :title="item.name"
              >
                <b-img-lazy
                  class="single-image"
                  :id="item.images[index-1].src"
                  :src="item.images[index-1].src"
                ></b-img-lazy>
                <!-- <div :id="'zoom' + item.images[index-1].src" class="img-zoom-result"></div> -->
              </b-modal>
            </slide>
          </carousel-3d>
        </b-col>
        <b-col md="6">
          <!-- <div class="checkout">
            <b-row class="receipt-header">
              <div class="receipt-header-text">Receipt</div>
            </b-row>
            <b-row>
              <b-col class="price">
                <b-row>LE {{item.price.value}} ➔ {{item.name}}</b-row>
                <b-row v-for="addOn in selectedAddOns" :key="addOn.id">{{addOn}}</b-row>
              </b-col>
              <b-col class="total-price">
                <div class="total-price-text">Total Price: LE {{currentPrice}}</div>
              </b-col>
            </b-row>
          </div>-->
          <b-card-body class="product-info">
            <div class="choose-vars-div">
              <b-row>
                <b-col>
                  <b-dropdown
                    id="dropdown-left"
                    dropdown
                    no-flip
                    :text="itemVariant"
                    variant="outline-primary"
                    class="m-1"
                  >
                    <b-dropdown-item
                      v-for="variation in item.variations"
                      :key="variation"
                      @click="selectVariation(variation)"
                      href="#"
                    >{{ variation }}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
                <b-col>
                  <b-dropdown
                    id="dropdown-right"
                    dropdown
                    no-flip
                    text="Add-ons"
                    variant="outline-primary"
                    class="m-1"
                  >
                    <b-dropdown-item>
                      <div class="dropdown-item bg-white text-body">
                        <b-form-checkbox-group
                          stacked
                          v-model="selectedAddOns"
                          name="addOns"
                          :options="matchItemIdWithName(item.addOns)"
                          @click.native.stop
                        />
                      </div>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
                <b-col>
                  <div class="quantity-toggle">
                    <button @click="decrement()">&mdash;</button>
                    <input type="text" :value="quantity" readonly />
                    <button @click="increment()">&#xff0b;</button>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    v-b-toggle.accordion-1
                    variant="outline-primary"
                  >Description</b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  :visible="descriptionAccordionVisiblility"
                  accordion="my-accordion1"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>{{ item.details }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-2 variant="outline-primary">Specs</b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion2"
                  :visible="specsAccordionVisiblility"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <ul>
                        <li v-for="specs in item.features" :key="specs">{{specs}}</li>
                      </ul>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    v-b-toggle.accordion-4
                    variant="outline-primary"
                  >Documents and attachements</b-button>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion3" role="tabpanel">
                  <b-card-body>
                    <ul>
                      <li>
                        Here
                        <a :href="item.link" target="_blank">Google Drive Link</a> you can find
                      </li>
                      <ol>
                        <li v-for="content in item.linkContains" :key="content">{{content}}</li>
                      </ol>
                    </ul>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedVars: [],
      selectedAddOns: [],
      quantity: 1,
      itemVariant: "Variations",
      descriptionAccordionVisiblility: false,
      specsAccordionVisiblility: false,
      currentPrice: this.item.price.value
    };
  },
  name: "SingleStoreItem",
  // To use props, they must be declared
  props: {
    item: Object
  },
  watch: {
    selectedAddOns() {
      var allAddOnsPrice = 0;
      for (var i = 0; i < this.selectedAddOns.length; i++) {
        allAddOnsPrice += parseInt(this.selectedAddOns[i].split(" ")[1]);
      }

      this.currentPrice =
        this.quantity * this.item.price.value + allAddOnsPrice;
    }
  },
  methods: {
    getParent(name) {
      let p = this.$parent;
      while (typeof p !== "undefined") {
        if (p.$options.name == name) {
          return p;
        } else {
          p = p.$parent;
        }
      }
      return false;
    },
    matchItemIdWithName(addOns) {
      var addOnsNames = [];
      for (var i = 0; i < addOns.length; i++) {
        var items = this.$parent.$parent.$parent.$parent.items;
        var targetItemIndex = items.findIndex(x => x.id === addOns[i]);
        if (targetItemIndex == -1) continue;
        var targetItem = items[targetItemIndex];
        addOnsNames.push(
          "LE " + targetItem.price.value + " ➔ " + targetItem.name
        );
      }
      return addOnsNames;
    },
    increment() {
      this.quantity++;
      this.currentPrice += this.item.price.value;
    },
    decrement() {
      if (this.quantity === 1) {
        alert("Negative or zero quantity not allowed");
      } else {
        this.quantity--;
        this.currentPrice -= this.item.price.value;
      }
    },
    selectVariation(variation) {
      this.itemVariant = variation;
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => window.dispatchEvent(new Event("resize")));
    }, 1);
  }
};
</script>

<style scoped>
.product-info {
  overflow-y: scroll;
  max-height: 300px;
  padding-left: 15px !important;
}
.p-1 {
  background-color: #fff;
  border-bottom: 0;
}
.carousel-3d-container {
  visibility: visible;
  height: 100% !important;
  padding-top: 10px !important;
}

.carousel-3d-slide.current {
  box-shadow: 0px 2px 8px 2px #327be6;
}
.carousel-3d-slide.right-1 {
  opacity: 0.9 !important;
}
.carousel-3d-slide.left-1 {
  opacity: 0.9 !important;
}
.choose-vars-div {
  width: 100%;
  margin-bottom: 20px;
  left: 10px;
  position: relative;
}
.choose-vars-div .row {
  width: 100%;
  margin-right: 0px !important;
  margin-left: 0px !important;
}
.choose-vars-div .col {
  width: 100%;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.img-zoom-lens {
  position: absolute;
  border: 1px solid #d4d4d4;
  /*set the size of the lens:*/
  width: 40px;
  height: 40px;
}
.checkout {
  margin: 15px;
  margin-bottom: 0px;
  border-bottom: 1px dotted black;
  padding-bottom: 20px;
}
.checkout .row {
  margin-left: 0px !important;
}
.receipt-header {
  display: flex;
  justify-content: center;
}
.receipt-header-text {
  width: 90%;
  border-bottom: 1px dotted black;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.price {
  text-align: left;
}
.total-price {
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
}
.total-price-text {
  position: absolute;
  bottom: 0px;
  right: 15px;
}
.single-image:hover .img-zoom-result {
  display: block;
}
.single-image {
  width: 100%;
}
pre {
  background: #eee;
  padding: 1rem;
  border-radius: 5px;
}

.quantity-toggle {
  display: flex;
  justify-content: center;
  height: 38px;
}
.quantity-toggle input {
  border: 0;
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
  width: 2.5rem;
  text-align: center;
  padding: 0 0.5rem;
}

.quantity-toggle button {
  border: 2px solid #ddd;
  background: #f5f5f5;
  color: #888;
  font-size: 1rem;
  cursor: pointer;
}
.quantity-toggle button:focus {
  outline: 0px auto -webkit-focus-ring-color;
}
.upper-button {
  width: 100%;
}
.col .m-1 {
  margin: 0rem !important;
  width: 98%;
}
.img-zoom-result {
  display: none;
  border: 1px solid #d4d4d4;
  /*set the size of the result div:*/
  width: 250px;
  height: 250px;
  position: absolute;
}
.dropdown-item {
  padding: 0.15rem 0.5rem !important;
}
.btn-outline-primary {
  -webkit-transition: font-size 0.2s ease;
  -moz-transition: font-size 0.2s ease;
  -o-transition: font-size 0.2s ease;
  -ms-transition: font-size 0.2s ease;
  transition: font-size 0.2s ease;
}

#dropdown-right .btn-outline-primary:hover {
  background-color: white !important;
  color: #007bff !important;
  font-size: 120%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.btn-outline-primary:hover {
  background-color: white !important;
  color: #007bff !important;
  font-size: 120%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.btn:focus {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
@media screen and (max-width: 500px) {
  .choose-vars-div .row {
    margin-left: -10px !important;
  }
  .choose-vars-div .col {
    margin-bottom: 10px !important;
  }
}
</style>
